export const handlePaginationList = (page, rowsPerPage, list) => {
    let startIndex = page * rowsPerPage;
    let lastIndex = startIndex + rowsPerPage;
    let paginatedList = list?.slice(startIndex, lastIndex);
    return paginatedList;
}

export const updateTableSortConfigObject = (configObject, isSortByAsc, currentSortBy, nextSortBy) => {
    let newHeadingArray = configObject.headings.map(item => {
        if (item.headingLabel === nextSortBy && nextSortBy !== "Actions") {
            item.icon = isSortByAsc ? "sort-alpha-down" : "sort-alpha-up";
        } else {
        //if (nextSortBy !== currentSortBy && item.headingLabel === currentSortBy && nextSortBy !== "Actions") {
            item.icon = "";
        }
        return item;
    });
    delete configObject.headings
    configObject.headings = newHeadingArray;
    return configObject;
}

export const showSeasonTableSortList = (type, typeField, list, isSortByAsc) => {
     let sortedList;
     switch (type) {
     case "Name":
         sortedList = list?.sort((a, b) => {
        const aValue = a[typeField];
        const bValue = b[typeField];
        if (aValue === null && bValue !== null) return isSortByAsc ? -1 : 1;
        if (bValue === null && aValue !== null) return isSortByAsc ? 1 : -1;
        if (aValue === null && bValue === null) return 0; 
        const aName = aValue.toString().split(' ').join('').toLowerCase();
        const bName = bValue.toString().split(' ').join('').toLowerCase();
        if (isSortByAsc) {
            return aName > bName ? 1 : aName < bName ? -1 : 0;
        } else {
            return bName > aName ? 1 : bName < aName ? -1 : 0;
        }
       });
       break;
    case "Date":
         sortedList = list?.sort((a, b) => {
         const rawA = a[typeField];
         const rawB = b[typeField];
       const isNullA = rawA == null || rawA === 'None';
        const isNullB = rawB == null || rawB === 'None';
         if (isNullA && !isNullB) return isSortByAsc ? -1 : 1;
         if (!isNullA && isNullB) return isSortByAsc ? 1 : -1;
         if (isNullA && isNullB) return 0;
         const parsedDateA = new Date(rawA);
         const parsedDateB = new Date(rawB);
        return isSortByAsc ? parsedDateA - parsedDateB: parsedDateB - parsedDateA;
        });
        break;
      
        case "Number":
         if (isSortByAsc) {
            sortedList = list?.sort((a, b) => {
             const numA = String(a[typeField] || '').replace(/\D/g, '');
             const numB = String(b[typeField] || '').replace(/\D/g, '');
            return Number(numA) - Number(numB); });
            } else {
            sortedList = list?.sort((a, b) => {
             const numA = String(a[typeField] || '').replace(/\D/g, '');
             const numB = String(b[typeField] || '').replace(/\D/g, '');
             return Number(numB) - Number(numA); });
                }
         break;
         case "Boolean":
          sortedList = list?.sort((a, b) => {
             const valA = Number(Boolean(a[typeField])); 
             const valB = Number(Boolean(b[typeField]));
             return isSortByAsc ? valA - valB : valB - valA;  });  
         break; 
        }
        return sortedList;
    }
export const tableSortList = (type, typeField, list, isSortByAsc) => {
    let sortedList;
    switch (type) {
        case "Name":
            if (isSortByAsc) {
                sortedList = list?.sort((a, b) => (a[typeField]?.toString().split(' ').join('').toLowerCase() > b[typeField]?.toString().split(' ').join('').toLowerCase()) ? 1 : -1);
            } else {
                sortedList = list?.sort((a, b) => (b[typeField]?.toString().split(' ').join('').toLowerCase() > a[typeField]?.toString().split(' ').join('').toLowerCase()) ? 1 : -1);
            }
            break;

        case "Date":
            if (isSortByAsc) {
                sortedList = list?.sort((a, b) => (Date.parse(a[typeField]?.toString().trim()) > Date.parse(b[typeField]?.toString().trim())) ? 1 : -1);
            } else {
                sortedList = list?.sort((a, b) => (Date.parse(b[typeField]?.toString().trim()) > Date.parse(a[typeField]?.toString().trim())) ? 1 : -1);
            }
            break;
        case "Number":
            if (isSortByAsc) {
                sortedList = list?.sort((a, b) => {
                    const numA = (a[typeField] || '').replace(/\D/g, '');
                    const numB = (b[typeField] || '').replace(/\D/g, '');
                    return numA.localeCompare(numB);
                });
            } else {
                sortedList = list?.sort((a, b) => {
                    const numA = (a[typeField] || '').replace(/\D/g, '');
                    const numB = (b[typeField] || '').replace(/\D/g, '');
                    return numB.localeCompare(numA);
                });
            }
            break;
    }
    return sortedList;
}


export const applyFilterTable = (config, data, filterValues, filtersNone) => {
    var finalList = [];
    var finalResult = [];
    var primaryKey = config.primaryKey;
    if (!filtersNone) {

        filterValues.map((filter) => {
            var keyValue = filter.split(":");
            var name = keyValue[0].trim();
            var value = keyValue[1].trim().toLowerCase();

            var index = -1; // Object.keys(config?.headings).indexOf((item) => config?.headings[item].headingLabel == name);

            Object.keys(config?.headings).map((item) => {
                console.log(config?.headings[item])
                if (config?.headings[item].headingLabel == name) {
                    index = item;
                    return;
                }
            });

            var nodeName = config?.dataNodes[index];
            var filteredList = data?.filter((item) => item[nodeName] != null ? item[nodeName].toString().toLowerCase().indexOf(value) > -1 : false);
            finalResult = finalResult.concat(filteredList?.filter((list) => !finalResult.find(p => p[primaryKey] == list[primaryKey])));

        });
    }
    else {
        finalResult = data;
    }
    //this.setState({filteredList : finalResult});    
    return finalResult;
   }

